import { Team } from '../../../../../../types/sport';
import { ESPN_HEROS_BASE_URL } from '../../urls';
import { ESPN_HERO_LALIGA_PLAYER_IMAGES } from './laliga-player-images';

const BASE_FACE_URL = `${ESPN_HEROS_BASE_URL}/la-liga`;

export const ESPN_HERO_LALIGA_TEAMS: Team[] = [
  {
    value: 'alaves',
    label: 'Alavés',
    players: [
      {
        value: 'antonio-blanco',
        label: 'Antonio Blanco',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/alaves/antonio-blanco/face/antonio-blanco.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.alaves['antonio-blanco']
      },
      {
        value: 'carlos-vicente',
        label: 'Carlos Vicente',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/alaves/carlos-vicente/face/carlos-vicente.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.alaves['carlos-vicente']
      },
      {
        value: 'lucas-boye',
        label: 'Lucas Boyé',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/alaves/lucas-boye/face/lucas-boye.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.alaves['lucas-boye']
      },
      {
        value: 'mariano-diaz',
        label: 'Mariano Díaz',
        country: 'republica_dominicana',
        imageUrl: `${BASE_FACE_URL}/alaves/mariano-diaz/face/mariano-diaz.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.alaves['mariano-diaz']
      },
      {
        value: 'nahuel-tenaglia',
        label: 'Nahuel Tenaglia',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/alaves/nahuel-tenaglia/face/nahuel-tenaglia.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.alaves['nahuel-tenaglia']
      }
    ]
  },
  {
    value: 'athletic-club',
    label: 'Athletic Club',
    players: [
      {
        value: 'aymeric-laporte',
        label: 'Aymeric Laporte',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/athletic-club/aymeric-laporte/face/aymeric-laporte.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['athletic-club']['aymeric-laporte']
      },
      {
        value: 'alex-berenguer',
        label: 'Álex Berenguer',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/athletic-club/alex-berenguer/face/alex-berenguer.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['athletic-club']['alex-berenguer']
      },
      {
        value: 'inaki-williams',
        label: 'Iñaki Williams',
        country: 'ghana',
        imageUrl: `${BASE_FACE_URL}/athletic-club/inaki-williams/face/inaki-williams.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['athletic-club']['inaki-williams']
      },
      {
        value: 'nico-williams',
        label: 'Nico Williams',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/athletic-club/nico-williams/face/nico-williams.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['athletic-club']['nico-williams']
      },
      {
        value: 'unai-gomez',
        label: 'Unai Gómez',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/athletic-club/unai-gomez/face/unai-gomez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['athletic-club']['unai-gomez']
      }
    ]
  },
  {
    value: 'atletico-madrid',
    label: 'Atlético de Madrid',
    players: [
      {
        value: 'thiago-almada',
        label: 'Thiago Almada',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/atletico-madrid/thiago-almada/face/thiago-almada.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['atletico-madrid']['thiago-almada']
      },
      {
        value: 'jose-maria-gimenez',
        label: 'José María Giménez',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/atletico-madrid/jose-maria-gimenez/face/jose-maria-gimenez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['atletico-madrid']['jose-maria-gimenez']
      },
      {
        value: 'giuliano-simeone',
        label: 'Giuliano Simeone',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/atletico-madrid/giuliano-simeone/face/giuliano-simeone.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['atletico-madrid']['giuliano-simeone']
      },
      {
        value: 'antoine-griezmann',
        label: 'Antoine Griezmann',
        country: 'francia',
        imageUrl: `${BASE_FACE_URL}/atletico-madrid/antoine-griezmann/face/antoine-griezmann.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['atletico-madrid']['antoine-griezmann']
      },
      {
        value: 'julian-alvarez',
        label: 'Julián Álvarez',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/atletico-madrid/julian-alvarez/face/julian-alvarez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['atletico-madrid']['julian-alvarez']
      },
      {
        value: 'alexander-sorloth',
        label: 'Alexander Sørloth',
        country: 'noruega',
        imageUrl: `${BASE_FACE_URL}/atletico-madrid/alexander-sorloth/face/alexander-sorloth.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['atletico-madrid']['alexander-sorloth']
      }
    ]
  },
  {
    value: 'barcelona',
    label: 'FC Barcelona',
    players: [
      {
        value: 'ronald-araujo',
        label: 'Ronald Araújo',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/barcelona/ronald-araujo/face/ronald-araujo.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.barcelona['ronald-araujo']
      },
      {
        value: 'robert-lewandowski',
        label: 'Robert Lewandowski',
        country: 'polonia',
        imageUrl: `${BASE_FACE_URL}/barcelona/robert-lewandowski/face/robert-lewandowski.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.barcelona['robert-lewandowski']
      },
      {
        value: 'pedro-gonzalez',
        label: 'Pedro González',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/barcelona/pedro-gonzalez/face/pedro-gonzalez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.barcelona['pedro-gonzalez']
      },
      {
        value: 'raphael-dias-belloli',
        label: 'Raphael Dias Belloli',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/barcelona/raphael-dias-belloli/face/raphael-dias-belloli.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.barcelona['raphael-dias-belloli']
      },
      {
        value: 'lamine-yamal',
        label: 'Lamine Yamal',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/barcelona/lamine-yamal/face/lamine-yamal.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.barcelona['lamine-yamal']
      }
    ]
  },
  {
    value: 'celta',
    label: 'Celta',
    players: [
      {
        value: 'borja-iglesias',
        label: 'Borja Iglesias',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/celta/borja-iglesias/face/borja-iglesias.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.celta['borja-iglesias']
      },
      {
        value: 'iago-aspas',
        label: 'Iago Aspas',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/celta/iago-aspas/face/iago-aspas.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.celta['iago-aspas']
      },
      {
        value: 'marcos-alonso',
        label: 'Marcos Alonso',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/celta/marcos-alonso/face/marcos-alonso-.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.celta['marcos-alonso']
      },
      {
        value: 'mingueza',
        label: 'Mingueza',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/celta/mingueza/face/mingueza.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.celta['mingueza']
      }
    ]
  },
  {
    value: 'elche',
    label: 'Elche',
    players: [
      {
        value: 'andre-silva',
        label: 'Andre Silva',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/elche/andre-silva/face/andre-silva.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.elche['andre-silva']
      },
      {
        value: 'dituro',
        label: 'Dituro',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/elche/dituro/face/dituro.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.elche['dituro']
      },
      {
        value: 'fernando-redondo',
        label: 'Fernando Redondo',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/elche/fernando-redondo/face/fernando-redondo.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.elche['fernando-redondo']
      },
      {
        value: 'rafa-mir',
        label: 'Rafa Mir',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/elche/rafa-mir/face/rafa-mir.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.elche['rafa-mir']
      }
    ]
  },
  {
    value: 'espanyol',
    label: 'Espanyol',
    players: [
      {
        value: 'javi-puado',
        label: 'Javi Puado',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/espanyol/javi-puado/face/javi-puado.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.espanyol['javi-puado']
      },
      {
        value: 'kike-garcia',
        label: 'Kike Garcia',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/espanyol/kike-garcia/face/kike-garcia.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.espanyol['kike-garcia']
      },
      {
        value: 'leandro-cabrera',
        label: 'Leandro Cabrera',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/espanyol/leandro-cabrera/face/leandro-cabrera.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.espanyol['leandro-cabrera']
      },
      {
        value: 'pol-lozano',
        label: 'Pol Lozano',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/espanyol/pol-lozano/face/pol-lozano.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.espanyol['pol-lozano']
      }
    ]
  },
  {
    value: 'getafe',
    label: 'Getafe',
    players: [
      {
        value: 'adrian-liso',
        label: 'Adrian Liso',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/getafe/adrian-liso/face/adrian-liso.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.getafe['adrian-liso']
      },
      {
        value: 'arambarri',
        label: 'Arambarri',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/getafe/arambarri/face/arambarri.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.getafe['arambarri']
      },
      {
        value: 'domingos-duarte',
        label: 'Domingos Duarte',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/getafe/domingos-duarte/face/domingos-duarte.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.getafe['domingos-duarte']
      },
      {
        value: 'juan-antonio-iglesias',
        label: 'Juan Antonio Iglesias',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/getafe/juan-antonio-iglesias/face/juan-antonio-iglesias.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.getafe['juan-antonio-iglesias']
      },
      {
        value: 'kiko',
        label: 'Kiko',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/getafe/kiko/face/kiko.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.getafe['kiko']
      },
      {
        value: 'mayoral',
        label: 'Mayoral',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/getafe/mayoral/face/mayoral.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.getafe['mayoral']
      }
    ]
  },
  {
    value: 'girona',
    label: 'Girona',
    players: [
      {
        value: 'asprilla',
        label: 'Asprilla',
        country: 'colombia',
        imageUrl: `${BASE_FACE_URL}/girona/asprilla/face/asprilla.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.girona['asprilla']
      },
      {
        value: 'blind',
        label: 'Blind',
        country: 'paises_bajos',
        imageUrl: `${BASE_FACE_URL}/girona/blind/face/blind.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.girona['blind']
      },
      {
        value: 'stuani',
        label: 'Stuani',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/girona/stuani/face/stuani.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.girona['stuani']
      },
      {
        value: 'thomas-lemar',
        label: 'Thomas Lemar',
        country: 'francia',
        imageUrl: `${BASE_FACE_URL}/girona/thomas-lemar/face/thomas-lemar.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.girona['thomas-lemar']
      },
      {
        value: 'viktor-tsygankov',
        label: 'Viktor Tsygankov',
        country: 'ucrania',
        imageUrl: `${BASE_FACE_URL}/girona/viktor-tsygankov/face/viktor-tsygankov.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.girona['viktor-tsygankov']
      },
      {
        value: 'vitor-reis',
        label: 'Vitor Reis',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/girona/vitor-reis/face/vitor-reis.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.girona['vitor-reis']
      }
    ]
  },
  {
    value: 'levante',
    label: 'Levante',
    players: [
      {
        value: 'carlos-alvarez',
        label: 'Carlos Alvarez',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/levante/carlos-alvarez/face/carlos-alvarez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.levante['carlos-alvarez']
      },
      {
        value: 'ivan-romero',
        label: 'Ivan Romero',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/levante/ivan-romero/face/ivan-romero.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.levante['ivan-romero']
      },
      {
        value: 'matias-moreno',
        label: 'Matias Moreno',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/levante/matias-moreno/face/matias-moreno.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.levante['matias-moreno']
      },
      {
        value: 'maturro',
        label: 'Maturro',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/levante/maturro/face/maturro.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.levante['maturro']
      },
      {
        value: 'pablo-martinez',
        label: 'Pablo Martinez',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/levante/pablo-martinez/face/pablo-martinez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.levante['pablo-martinez']
      }
    ]
  },
  {
    value: 'mallorca',
    label: 'Mallorca',
    players: [
      {
        value: 'maffeo',
        label: 'Maffeo',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/mallorca/maffeo/face/maffeo.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.mallorca['maffeo']
      },
      {
        value: 'mojica',
        label: 'Mojica',
        country: 'colombia',
        imageUrl: `${BASE_FACE_URL}/mallorca/mojica/face/mojica.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.mallorca['mojica']
      },
      {
        value: 'muriqi',
        label: 'Muriqi',
        country: 'kosovo',
        imageUrl: `${BASE_FACE_URL}/mallorca/muriqi/face/muriqi.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.mallorca['muriqi']
      }
    ]
  },
  {
    value: 'osasuna',
    label: 'Osasuna',
    players: [
      {
        value: 'boyomo',
        label: 'Boyomo',
        country: 'camerun',
        imageUrl: `${BASE_FACE_URL}/osasuna/boyomo/face/boyomo.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.osasuna['boyomo']
      },
      {
        value: 'budimir',
        label: 'Budimir',
        country: 'croacia',
        imageUrl: `${BASE_FACE_URL}/osasuna/budimir/face/budimir.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.osasuna['budimir']
      },
      {
        value: 'oroz',
        label: 'Oroz',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/osasuna/oroz/face/oroz.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.osasuna['oroz']
      }
    ]
  },
  {
    value: 'rayo-vallecano',
    label: 'Rayo Vallecano',
    players: [
      {
        value: 'alvaro-garcia',
        label: 'Alvaro Garcia',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/rayo-vallecano/alvaro-garcia/face/alvaro-garcia.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['rayo-vallecano']['alvaro-garcia']
      },
      {
        value: 'andrei',
        label: 'Andrei',
        country: 'rumania',
        imageUrl: `${BASE_FACE_URL}/rayo-vallecano/andrei/face/andrei.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['rayo-vallecano']['andrei']
      },
      {
        value: 'batalla',
        label: 'Batalla',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/rayo-vallecano/batalla/face/batalla.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['rayo-vallecano']['batalla']
      },
      {
        value: 'de-frutos',
        label: 'De Frutos',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/rayo-vallecano/de-frutos/face/de-frutos.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['rayo-vallecano']['de-frutos']
      },
      {
        value: 'isi-palazon',
        label: 'Isi Palazon',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/rayo-vallecano/isi-palazon/face/isi-palazon.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['rayo-vallecano']['isi-palazon']
      },
      {
        value: 'luiz-felipe',
        label: 'Luiz Felipe',
        country: 'italia',
        imageUrl: `${BASE_FACE_URL}/rayo-vallecano/luiz-felipe/face/luiz-felipe.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['rayo-vallecano']['luiz-felipe']
      },
      {
        value: 'trejo',
        label: 'Trejo',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/rayo-vallecano/trejo/face/trejo.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['rayo-vallecano']['trejo']
      },
      {
        value: 'unai-lopez',
        label: 'Unai Lopez',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/rayo-vallecano/unai-lopez/face/unai-lopez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['rayo-vallecano']['unai-lopez']
      }
    ]
  },
  {
    value: 'real-betis',
    label: 'Real Betis',
    players: [
      {
        value: 'antony',
        label: 'Antony',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/real-betis/antony/face/antony.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-betis']['antony']
      },
      {
        value: 'cucho-hernandez',
        label: 'Cucho Hernandez',
        country: 'colombia',
        imageUrl: `${BASE_FACE_URL}/real-betis/cucho-hernandez/face/cucho-hernandez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-betis']['cucho-hernandez']
      },
      {
        value: 'giovani-lo-celso',
        label: 'Giovani Lo Celso',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/real-betis/giovani-lo-celso/face/giovani-lo-celso.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-betis']['giovani-lo-celso']
      },
      {
        value: 'natan',
        label: 'Natan',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/real-betis/natan/face/natan.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-betis']['natan']
      },
      {
        value: 'nelson-deossa',
        label: 'Nelson Deossa',
        country: 'colombia',
        imageUrl: `${BASE_FACE_URL}/real-betis/nelson-deossa/face/nelson-deossa.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-betis']['nelson-deossa']
      },
      {
        value: 'pablo-fornals',
        label: 'Pablo Fornals',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/real-betis/pablo-fornals/face/pablo-fornals.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-betis']['pablo-fornals']
      },
      {
        value: 'valentin-gomez',
        label: 'Valentin Gomez',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/real-betis/valentin-gomez/face/valentin-gomez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-betis']['valentin-gomez']
      }
    ]
  },
  {
    value: 'real-madrid',
    label: 'Real Madrid',
    players: [
      {
        value: 'federico-valverde',
        label: 'Federico Valverde',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/real-madrid/federico-valverde/face/federico-valverde.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-madrid']['federico-valverde']
      },
      {
        value: 'franco-mastantuono',
        label: 'Franco Mastantuono',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/real-madrid/franco-mastantuono/face/franco-mastantuono.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-madrid']['franco-mastantuono']
      },
      {
        value: 'jude-bellingham',
        label: 'Jude Bellingham',
        country: 'inglaterra',
        imageUrl: `${BASE_FACE_URL}/real-madrid/jude-bellingham/face/jude-bellingham.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-madrid']['jude-bellingham']
      },
      {
        value: 'kylian-mbappe',
        label: 'Kylian Mbappe',
        country: 'francia',
        imageUrl: `${BASE_FACE_URL}/real-madrid/kylian-mbappe/face/kylian-mbappe.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-madrid']['kylian-mbappe']
      },
      {
        value: 'vini-jrs',
        label: 'Vini Jrs',
        country: 'brasil',
        imageUrl: `${BASE_FACE_URL}/real-madrid/vini-jrs/face/vini-jrs.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-madrid']['vini-jrs']
      }
    ]
  },
  {
    value: 'real-oviedo',
    label: 'Real Oviedo',
    players: [
      {
        value: 'david-costas',
        label: 'David Costas',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/real-oviedo/david-costas/face/david-costas.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-oviedo']['david-costas']
      },
      {
        value: 'fede-vinas',
        label: 'Fede Vinas',
        country: 'uruguay',
        imageUrl: `${BASE_FACE_URL}/real-oviedo/fede-vinas/face/fede-vinas.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-oviedo']['fede-vinas']
      },
      {
        value: 'haissem-hassan',
        label: 'Haissem Hassan',
        country: 'egipto',
        imageUrl: `${BASE_FACE_URL}/real-oviedo/haissem-hassan/face/haissem-hassan.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-oviedo']['haissem-hassan']
      },
      {
        value: 'ilyas-chaira',
        label: 'Ilyas Chaira',
        country: 'marruecos',
        imageUrl: `${BASE_FACE_URL}/real-oviedo/ilyas-chaira/face/ilyas-chaira.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-oviedo']['ilyas-chaira']
      },
      {
        value: 'nacho-vidal',
        label: 'Nacho Vidal',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/real-oviedo/nacho-vidal/face/nacho-vidal.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-oviedo']['nacho-vidal']
      },
      {
        value: 'santiago-cazorla',
        label: 'Santiago Cazorla',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/real-oviedo/santiago-cazorla/face/santiago-cazorla.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-oviedo']['santiago-cazorla']
      },
      {
        value: 'santiago-colombatto',
        label: 'Santiago Colombatto',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/real-oviedo/santiago-colombatto/face/santiago-colombatto.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-oviedo']['santiago-colombatto']
      }
    ]
  },
  {
    value: 'real-sociedad',
    label: 'Real Sociedad',
    players: [
      {
        value: 'aramburu',
        label: 'Aramburu',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/real-sociedad/aramburu/face/aramburu.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-sociedad']['aramburu']
      },
      {
        value: 'carlos-soler',
        label: 'Carlos Soler',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/real-sociedad/carlos-soler/face/carlos-soler.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-sociedad']['carlos-soler']
      },
      {
        value: 'gonzalo-guedes',
        label: 'Gonzalo Guedes',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/real-sociedad/gonzalo-guedes/face/gonzalo-guedes.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-sociedad']['gonzalo-guedes']
      },
      {
        value: 'jon-gorrotxategi',
        label: 'Jon Gorrotxategi',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/real-sociedad/jon-gorrotxategi/face/jon-gorrotxategi.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-sociedad']['jon-gorrotxategi']
      },
      {
        value: 'mikel-oyarzabal',
        label: 'Mikel Oyarzabal',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/real-sociedad/mikel-oyarzabal/face/mikel-oyarzabal.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-sociedad']['mikel-oyarzabal']
      },
      {
        value: 'takefusa-kubo',
        label: 'Takefusa Kubo',
        country: 'japon',
        imageUrl: `${BASE_FACE_URL}/real-sociedad/takefusa-kubo/face/takefusa-kubo.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES['real-sociedad']['takefusa-kubo']
      }
    ]
  },
  {
    value: 'sevilla',
    label: 'Sevilla',
    players: [
      {
        value: 'alexis-sanchez',
        label: 'Alexis Sanchez',
        country: 'chile',
        imageUrl: `${BASE_FACE_URL}/sevilla/alexis-sanchez/face/alexis-sanchez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.sevilla['alexis-sanchez']
      },
      {
        value: 'gabriel-suazo',
        label: 'Gabriel Suazo',
        country: 'chile',
        imageUrl: `${BASE_FACE_URL}/sevilla/gabriel-suazo/face/gabriel-suazo.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.sevilla['gabriel-suazo']
      },
      {
        value: 'januzaj-adnan',
        label: 'Januzaj Adnan',
        country: 'belgica',
        imageUrl: `${BASE_FACE_URL}/sevilla/januzaj-adnan/face/januzaj-adnan.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.sevilla['januzaj-adnan']
      }
    ]
  },
  {
    value: 'valencia',
    label: 'Valencia',
    players: [
      {
        value: 'andre-almeida',
        label: 'Andre Almeida',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/valencia/andre-almeida/face/andre-almeida.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.valencia['andre-almeida']
      },
      {
        value: 'arnaut-danjuma',
        label: 'Arnaut Danjuma',
        country: 'paises_bajos',
        imageUrl: `${BASE_FACE_URL}/valencia/arnaut-danjuma/face/arnaut-danjuma.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.valencia['arnaut-danjuma']
      },
      {
        value: 'diego-lopez',
        label: 'Diego Lopez',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/valencia/diego-lopez/face/diego-lopez.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.valencia['diego-lopez']
      },
      {
        value: 'gaya',
        label: 'Gaya',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/valencia/gaya/face/gaya.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.valencia['gaya']
      },
      {
        value: 'hugo-duro',
        label: 'Hugo Duro',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/valencia/hugo-duro/face/hugo-duro.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.valencia['hugo-duro']
      },
      {
        value: 'javi-guerra',
        label: 'Javi Guerra',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/valencia/javi-guerra/face/javi-guerra.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.valencia['javi-guerra']
      },
      {
        value: 'lucas-beltran',
        label: 'Lucas Beltran',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/valencia/lucas-beltran/face/lucas-beltran.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.valencia['lucas-beltran']
      }
    ]
  },
  {
    value: 'villarreal',
    label: 'Villarreal',
    players: [
      {
        value: 'foyth',
        label: 'Foyth',
        country: 'argentina',
        imageUrl: `${BASE_FACE_URL}/villarreal/foyth/face/foyth.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.villarreal['foyth']
      },
      {
        value: 'mikautadze',
        label: 'Mikautadze',
        country: 'georgia',
        imageUrl: `${BASE_FACE_URL}/villarreal/mikautadze/face/mikautadze.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.villarreal['mikautadze']
      },
      {
        value: 'moreno',
        label: 'Moreno',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/villarreal/moreno/face/moreno.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.villarreal['moreno']
      },
      {
        value: 'parejo',
        label: 'Parejo',
        country: 'espana',
        imageUrl: `${BASE_FACE_URL}/villarreal/parejo/face/parejo.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.villarreal['parejo']
      },
      {
        value: 'partey',
        label: 'Partey',
        country: 'ghana',
        imageUrl: `${BASE_FACE_URL}/villarreal/partey/face/partey.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.villarreal['partey']
      },
      {
        value: 'pepe',
        label: 'Pepe',
        country: 'portugal',
        imageUrl: `${BASE_FACE_URL}/villarreal/pepe/face/pepe.png`,
        images: ESPN_HERO_LALIGA_PLAYER_IMAGES.villarreal['pepe']
      }
    ]
  }
];
